import { useState } from "react";
import { X, GlobeHemisphereWest } from "@phosphor-icons/react";

// VAGUE 43 — Lead chaud site internet : détail du projet + accord du prospect.
export const PROJECT_TYPES = [
  { id: "site_vitrine", label: "Création de site vitrine" },
  { id: "refonte", label: "Refonte de site existant" },
  { id: "seo", label: "Améliorer le référencement" },
  { id: "boutique", label: "Boutique en ligne" },
  { id: "app_web", label: "Application web" },
];

const input = "w-full text-sm border border-border rounded-sm px-2.5 py-2 bg-background focus:border-primary outline-none";

export default function WebsiteLeadModal({ biz, onSubmit, onClose }) {
  const call = biz.call || {};
  const prev = call.website_lead || {};
  const [f, setF] = useState({
    contact_name: call.contact_name || "", contact_phone: call.contact_phone || biz.phone || "",
    contact_email: call.contact_email || biz.email || "",
    project_types: prev.project_types || [], budget: prev.budget || "",
    availability: prev.availability || "", comments: prev.comments || "", consent: !!prev.consent,
  });
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const toggle = (id) => set("project_types", f.project_types.includes(id) ? f.project_types.filter((x) => x !== id) : [...f.project_types, id]);
  const ok = f.project_types.length > 0 && f.consent && (f.contact_phone.trim() || f.contact_email.trim());

  const submit = () => onSubmit({
    status: "site_web_besoin",
    contact_name: f.contact_name.trim(), contact_phone: f.contact_phone.trim(), contact_email: f.contact_email.trim(),
    website_lead: { project_types: f.project_types, budget: f.budget, availability: f.availability, comments: f.comments, consent: f.consent },
  });

  return (
    <div className="fixed inset-0 z-[90] bg-foreground/60 backdrop-blur-sm flex items-end sm:items-center justify-center p-2 sm:p-6"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }} data-testid={`website-lead-modal-${biz.id}`}>
      <div className="bg-card border border-border rounded-sm shadow-xl w-full max-w-lg max-h-[92vh] flex flex-col">
        <div className="flex items-start justify-between gap-2 px-4 py-3 border-b border-border bg-[#1a5f8a]/10">
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-widest font-bold text-[#1a5f8a] flex items-center gap-1">
              <GlobeHemisphereWest size={12} weight="bold"/> Lead site internet — Digital Corp France
            </div>
            <div className="font-display font-semibold text-sm truncate">{biz.name}</div>
          </div>
          <button type="button" onClick={onClose} className="p-1 text-muted-foreground hover:text-foreground" aria-label="Fermer" data-testid="website-lead-close"><X size={16}/></button>
        </div>
        <div className="overflow-y-auto p-4 space-y-3">
          <div className="grid sm:grid-cols-3 gap-2">
            <input className={input} placeholder="Nom du contact" value={f.contact_name} onChange={(e) => set("contact_name", e.target.value)} data-testid="website-lead-contact-name"/>
            <input className={input} placeholder="Téléphone" value={f.contact_phone} onChange={(e) => set("contact_phone", e.target.value)} data-testid="website-lead-contact-phone"/>
            <input className={input} placeholder="E-mail" value={f.contact_email} onChange={(e) => set("contact_email", e.target.value)} data-testid="website-lead-contact-email"/>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground mb-1.5">Nature du projet *</div>
            <div className="flex flex-wrap gap-1.5">
              {PROJECT_TYPES.map((p) => (
                <button key={p.id} type="button" onClick={() => toggle(p.id)}
                  className={`text-xs font-semibold border rounded-full px-3 py-1.5 ${f.project_types.includes(p.id) ? "bg-[#1a5f8a] text-white border-[#1a5f8a]" : "bg-background border-border hover:border-[#1a5f8a]"}`}
                  data-testid={`website-lead-type-${p.id}`}>{p.label}</button>
              ))}
            </div>
          </div>
          <input className={input} placeholder="Budget communiqué (facultatif)" maxLength={80} value={f.budget} onChange={(e) => set("budget", e.target.value)} data-testid="website-lead-budget"/>
          <input className={input} placeholder="Disponibilité pour un rappel (ex : mardi après-midi)" maxLength={200} value={f.availability} onChange={(e) => set("availability", e.target.value)} data-testid="website-lead-availability"/>
          <textarea className={input} rows={3} placeholder="Commentaires du télépro" maxLength={1000} value={f.comments} onChange={(e) => set("comments", e.target.value)} data-testid="website-lead-comments"/>
          <label className="flex items-start gap-2 text-sm cursor-pointer" data-testid="website-lead-consent-label">
            <input type="checkbox" checked={f.consent} onChange={(e) => set("consent", e.target.checked)} className="mt-1" data-testid="website-lead-consent"/>
            <span>Le prospect accepte d&apos;être recontacté par Digital Corp France pour ce projet. *</span>
          </label>
        </div>
        <div className="flex justify-end gap-2 px-4 py-3 border-t border-border">
          <button type="button" onClick={onClose} className="text-xs font-semibold border border-border rounded-sm px-3 py-2" data-testid="website-lead-cancel">Annuler</button>
          <button type="button" onClick={submit} disabled={!ok}
            className="text-xs font-bold bg-[#1a5f8a] text-white rounded-sm px-4 py-2 disabled:opacity-50 disabled:cursor-not-allowed" data-testid="website-lead-submit">
            Créer le lead chaud
          </button>
        </div>
      </div>
    </div>
  );
}
